import script from "./Unauthorized.vue?vue&type=script&setup=true&lang=js"
export * from "./Unauthorized.vue?vue&type=script&setup=true&lang=js"

import "./Unauthorized.vue?vue&type=style&index=0&id=5a32da7b&lang=css"

const __exports__ = script;

export default __exports__